<template>
  <bm-number
    v-bind="$attrs"
    v-model="internalConvertedValue"
    :suffix="unitPreference.suffix"
    :max-decimal-places="maxDecimalPlaces ?? unitPreference.maxDecimalPlaces"
    :placeholder="placeholderText"
    @blur="onBlur"
  />
</template>

<script lang="ts">
import type { PropType } from "vue";
import { computed, defineComponent, ref, watch } from "vue";
import {
  tenantService,
  type UnitDisplayPreference,
} from "@/app/services/extensions/tenantServiceExtended";

export default defineComponent({
  name: "BmUnitBase",
  props: {
    value: {
      type: Number as PropType<number | null>,
      default: null,
      required: false,
    },
    unitPreference: {
      type: Object as PropType<UnitDisplayPreference<any>>,
      required: true,
    },
    maxDecimalPlaces: {
      type: Number,
      default: undefined,
    },
    placeholderValue: {
      type: Number as PropType<number | null>,
      default: null,
      required: false,
    },
  },
  setup(props, context) {
    const internalConvertedValue = ref<number | null>(null);

    const placeholderText = computed(() =>
      props.placeholderValue === null
        ? null
        : tenantService
            .roundNumber(
              props.placeholderValue *
                props.unitPreference.conversionMultiplierFromBaseUnit
            )
            .toString()
    );

    watch(
      () => props.value,
      () => {
        internalConvertedValue.value =
          props.value !== null
            ? props.value *
              props.unitPreference.conversionMultiplierFromBaseUnit
            : null;
      },
      { immediate: true }
    );

    return {
      internalConvertedValue,
      placeholderText,
      onBlur: () => {
        // Use on blur to prevent updating value when user is inputting
        context.emit(
          "input",
          internalConvertedValue.value !== null
            ? internalConvertedValue.value /
                props.unitPreference.conversionMultiplierFromBaseUnit
            : null
        );
      },
    };
  },
});
</script>
